import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const envName = () =>
  getGlobalProperty<string>("envName") ?? process.env.env;
